import { ItalicIcon, UnderlineIcon, styled, css } from 'canoe';
import React from 'react';

const IconCheckboxItemContainer = styled.div<{ isActive: boolean; disabled?: boolean }>`
  ${({ theme, isActive, disabled }) => css`
    display: flex;
    border-right: 1px solid ${theme.colors.border};
    padding: ${theme.spaces.xxs} ${theme.spaces.xs};
    background: ${isActive ? theme.colors.BrandPurple : theme.colors.White};
    cursor: pointer;
    align-items: center;

    ${disabled &&
    css`
      pointer-events: none;
    `}

    svg > path {
      fill: ${isActive ? theme.colors.White : theme.colors.GlitterGrayD10};
    }

    &:hover {
      background: ${isActive ? theme.colors.BrandPurple : theme.colors.White};
      svg > path {
        fill: ${isActive ? theme.colors.White : theme.colors.OnyxGrayL30};
      }
    }
  `}
`;

const Box = styled.div`
  ${({ theme }) => css`
    height: 40px;
    width: 76px;

    border: 1px solid ${theme.colors.border};
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;

    display: flex;

    > div:last-child {
      border-right: none;
    }
  `}
`;

interface IconCheckboxItemProps {
  active: boolean;
  children: React.ReactElement;
  onToggle: (bool: boolean) => void;
  disabled?: boolean;
}

export const IconCheckboxItem = ({
  children,
  active,
  onToggle,
  disabled,
}: IconCheckboxItemProps) => {
  return (
    <IconCheckboxItemContainer
      isActive={active}
      disabled={disabled}
      onClick={() => !disabled && onToggle(!active)}
    >
      {children}
    </IconCheckboxItemContainer>
  );
};

const textDecoration = [
  {
    variable: '--text-decoration',
    setting: 'underline',
    Icon: UnderlineIcon,
  },
  {
    variable: '--font-style',
    setting: 'italic',
    Icon: ItalicIcon,
  },
];

interface TextStylePickerProps {
  onChange: (prop: string, value: string) => void;
  properties: Record<string, string>;
  disabled?: boolean;
}

export const TextStylePicker = ({ properties, onChange, disabled }: TextStylePickerProps) => {
  return (
    <Box>
      {textDecoration.map(({ setting, variable, Icon }) => {
        const isActive = properties[variable] === setting;
        const onToggle = (bool: boolean) => {
          onChange(variable, bool ? setting : 'normal');
        };
        return (
          <IconCheckboxItemContainer
            tabIndex={0}
            key={setting}
            isActive={isActive}
            disabled={disabled}
            onClick={() => onToggle(!isActive)}
          >
            <Icon />
          </IconCheckboxItemContainer>
        );
      })}
    </Box>
  );
};
